module.exports = __webpack_public_path__ + "img/rain_yellow.f9e488fc.gif";